import { Grid } from '@mui/material';

interface LoginGridItemProps {
  children: React.ReactNode;
  disableTopSpacing?: boolean;
  disableBottomSpacing?: boolean;
}

function LoginGridItem({ children, disableTopSpacing, disableBottomSpacing }: LoginGridItemProps) {
  return (
    <Grid
      sx={{
        width: '100%',
        mt: disableTopSpacing ? '0px' : '10px',
        mb: disableBottomSpacing ? '0px' : '10px',
      }}
    >
      {children}
    </Grid>
  );
}

export default LoginGridItem;
